import axios from "axios";
import { CommonConstants } from "../constants/common-constants";
import {
  IHTTPRequestOptions,
  IHTTPResponse,
  IHTTPOptions,
} from "../models/httpModels";
import CookieHelper from "./cookieHelper";

axios.defaults.withCredentials = true;

export class HTTPService {
  private httpOptions?: IHTTPOptions;

  constructor(options?: IHTTPOptions) {
    this.httpOptions = options;
  }

  private getHeaders(isFileUpload = false): Record<string, string> {
    const headers: Record<string, string> = {
      authenticate_user: CookieHelper.get(CommonConstants.UserTokenKey),
    };
    if (isFileUpload) {
      headers["Content-Type"] = "multipart/form-data";
    }
    return headers;
  }

  get = async (
    url: string,
    options?: IHTTPRequestOptions
  ): Promise<IHTTPResponse> => {
    const response = await axios.get(encodeURI(url), {
      headers: this.getHeaders(),
      ...options,
    });
    return response;
  };

  post = async (
    url: string,
    data?: unknown,
    options?: IHTTPRequestOptions
  ): Promise<IHTTPResponse> => {
    const response = await axios.post(encodeURI(url), data, {
      headers: this.getHeaders(),
      ...options,
    });
    return response;
  };

  fileUpload = async (
    url: string,
    data?: FormData,
    options?: IHTTPRequestOptions
  ): Promise<IHTTPResponse> => {
    const response = await axios.post(encodeURI(url), data, {
      headers: this.getHeaders(true),
      ...options,
    });
    return response;
  };

  put = async (
    url: string,
    data?: unknown,
    options?: IHTTPRequestOptions
  ): Promise<IHTTPResponse> => {
    const response = await axios.put(encodeURI(url), data, {
      headers: this.getHeaders(),
      ...options,
    });
    return response;
  };

  patch = async (
    url: string,
    data?: unknown,
    options?: IHTTPRequestOptions
  ): Promise<IHTTPResponse> => {
    const response = await axios.patch(encodeURI(url), data, {
      headers: this.getHeaders(),
      ...options,
    });
    return response;
  };

  delete = async (
    url: string,
    options?: IHTTPRequestOptions
  ): Promise<IHTTPResponse> => {
    const response = await axios.delete(encodeURI(url), {
      headers: this.getHeaders(),
      ...options,
    });
    return response;
  };
}
